// Shared team data for consistent display across components
export const TEAM_DATA = {
  Griffins: { 
    image: "🦁", 
    text: "Brave and noble, Griffins are known for their courage and loyalty. They soar above challenges with grace and determination." 
  },
  Snakes: { 
    image: "🐍", 
    text: "Cunning and ambitious, Snakes are strategic thinkers who value resourcefulness and achievement." 
  },
  Badgers: { 
    image: "🦡", 
    text: "Hardworking and dedicated, Badgers are loyal friends who value patience, honesty, and fair play." 
  },
  Eagles: { 
    image: "🦅", 
    text: "Wise and creative, Eagles value intelligence, learning, and wit. They seek knowledge and understanding." 
  },
} as const;

export type TeamKey = keyof typeof TEAM_DATA;

export const getTeamImage = (team: string | null | undefined): string => {
  if (!team) return "❓";
  return TEAM_DATA[team as TeamKey]?.image || "❓";
};

export const getTeamText = (team: string | null | undefined): string => {
  if (!team) return "No team selected yet";
  return TEAM_DATA[team as TeamKey]?.text || "No team selected yet";
};